import { Api } from '@axiom/ui';
import type {
  UserCandidateSearch,
  UserOpportunitySearch,
  UserSearch,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

type UpdateUserSearchType = {
  alertActive: UserSearch['alertActive'];
  id: UserSearch['id'];
  name: UserSearch['name'];
};

class UserSearchesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  async createUserSearch(
    body: Partial<UserCandidateSearch | UserOpportunitySearch>
  ) {
    return super.write<{ data: null }>({
      endpoint: `/users/searches`,
      body,
      method: 'POST',
    });
  }

  readUserSearches(type: UserSearch['type']) {
    return super.read<{
      data: UserCandidateSearch[] | UserOpportunitySearch[];
    }>({
      endpoint: `/users/searches?type=${type}`,
      method: 'GET',
    });
  }

  readUserSearch(id: UserSearch['id']) {
    return super.read<{ data: UserCandidateSearch | UserOpportunitySearch }>({
      endpoint: `/users/searches/${id}`,
      method: 'GET',
    });
  }

  async updateUserSearch(id: UserSearch['id'], body: UpdateUserSearchType) {
    return super.write<{ data: null }>({
      endpoint: `/users/searches/${id}`,
      body,
      method: 'PATCH',
    });
  }

  async updateUserSearches(userSearches: UpdateUserSearchType[]) {
    return super.write<{ data: null }>({
      endpoint: `/users/searches`,
      body: { userSearches },
      method: 'PATCH',
    });
  }

  async deleteUserSearch(id: UserSearch['id']) {
    return super.write<{ data: null }>({
      endpoint: `/users/searches/${id}`,
      method: 'DELETE',
    });
  }

  async refreshUserSearches(type: UserSearch['type']) {
    return super.invalidate(`/users/searches?type=${type}`);
  }

  async refreshAllUserSearchTypes() {
    return Promise.all([
      super.invalidate(`/users/searches?type=candidate`),
      super.invalidate(`/users/searches?type=opportunity`),
    ]);
  }
}

export const UserSearchesApi = new UserSearchesApiClass();
